export const GET_SUBSCRIBER_LIST = "GET_SUBSCRIBER_LIST";
export const SUBSCRIBER_PROCESSING = "SUBSCRIBER_PROCESSING";
export const STOP_SUBSCRIBER_PROCESSING = "STOP_SUBSCRIBER_PROCESSING";
